import { CloudOff, Lock, SearchX, ServerCrash, TriangleAlert } from 'lucide-react';
import { ApiError, NetworkError } from '../lib/api';
import { Button } from './Button';
import { EmptyState } from './misc';

export function describeError(error: unknown) {
  if (error instanceof NetworkError) {
    return { icon: CloudOff, title: 'Can’t reach WITTCO RMM', body: 'Check your connection, then try again.', retry: true };
  }
  if (error instanceof ApiError) {
    if (error.status === 400) return { icon: TriangleAlert, title: 'These filters aren’t valid', body: 'Something in this view couldn’t be read. Reset the filters and try again.', retry: false };
    if (error.status === 403) return { icon: Lock, title: 'You don’t have access here', body: 'Your access to this workspace changed. Choose a workspace you can still use.', retry: false };
    if (error.status === 404) return { icon: SearchX, title: 'Not found', body: 'This record doesn’t exist, or isn’t available to you.', retry: false };
    if (error.status === 401) return { icon: Lock, title: 'Your session ended', body: 'Sign in again to continue.', retry: false };
  }
  return { icon: ServerCrash, title: 'Something went wrong', body: 'The request didn’t complete. Nothing was changed.', retry: true };
}

export function ErrorPanel({ error, onRetry, className }: { error: unknown; onRetry?: () => void; className?: string }) {
  const d = describeError(error), Icon = d.icon;
  return (
    <div role="alert" className={className}>
      <EmptyState icon={<Icon className="size-5" />} title={d.title}
        action={d.retry && onRetry ? <Button onClick={onRetry}>Try again</Button> : undefined}>{d.body}</EmptyState>
    </div>
  );
}
